var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"entete-img"},[_c('img',{attrs:{"src":require("../../../CCA_ENV_CONF/entete.png"),"alt":"Entete"}})])])
}]

export { render, staticRenderFns }